import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faXTwitter, 
  faLinkedin, 
  faInstagram, 
  faYoutube 
} from "@fortawesome/free-brands-svg-icons";

const Header = () => {
  return (
    <header className="flex flex-col lg:flex-row justify-between items-center bg-[#003a7c] text-white px-2.5 md:px-44 py-2">
      <div className="flex flex-row justify-between items-center w-full md:w-auto gap-2 md:gap-4">
        <div className="font-nova-square ">
          <a 
            href="mailto:support@Kristellar.com"
            className="flex items-center gap-1 text-sm md:text-sm"
          >
            📧 support@kristellar.com
          </a>
        </div>
        <div className="font-nova-square">
        <a href="tel:06742915135" className="text-sm md:text-sm">📞 +91 674 291 5135</a>
        </div>
      </div>
      
      <div className="hidden lg:flex justify-start items-center w-full md:w-auto gap-2.5 md:gap-5 mt-2 md:mt-0">
        <a 
          href="https://www.youtube.com/@KristellarAerospace" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white hover:text-[#1da1f2] transition-colors duration-300"
        >
          <FontAwesomeIcon icon={faYoutube} size="md" />
        </a>
        <a 
          href="https://x.com/Kristellar9610?t=mTVSv7wVxelsRl2uJ91d8A" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white hover:text-[#1da1f2] transition-colors duration-300"
        >
          <FontAwesomeIcon icon={faXTwitter} size="md" />
        </a>
        <a 
          href="https://www.linkedin.com/in/kristellar-aerospace-7b5328321/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white hover:text-[#1da1f2] transition-colors duration-300"
        >
          <FontAwesomeIcon icon={faLinkedin} size="md" />
        </a>
        <a 
          href="https://www.instagram.com/?next=%2F" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white hover:text-[#1da1f2] transition-colors duration-300"
        >
          <FontAwesomeIcon icon={faInstagram} size="md" />
        </a>
      </div>
    </header>
  );
};

export default Header;